import { ViewCustomAction } from '@msdk/common'
import { UserPath } from '@msdk/definitions'

export class ApiAction extends ViewCustomAction {
  public async onClick() {
    const ids = this.selectedRows.map((e) => e.id)
    const params = new URLSearchParams()
    params.append('entityName', this.entityName)
    ids.forEach((id) => params.append('selectedIds', id))
    await this.apiClient.read(this.api, params)
  }

  public isVisible() {
    if (!this.apiRequireClaim) {
      return true
    }

    const userPath = new UserPath()
    return userPath.HasClaim(this.apiRequireClaim)
  }

  public isDisabled() {
    return false
  }
}
